import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-billing-address-popup',
  templateUrl: './billing-address-popup.component.html',
  styleUrls: ['./billing-address-popup.component.scss']
})
export class BillingAddressPopupComponent implements OnInit {
  currentAddressSelected: any = "";
  isAcceptTermCondition: any = "";
  isShowTermConditions: boolean = false;
  currentPlanDetails: any = "";
  @Input() currentPlanData : any = "";
  constructor(
    private commonService: CommonService
  ) {}
  
  closeDialog() {
    let sendData = {
       actionType: "Close",
       selectedAddress: this.currentAddressSelected,
       currentDetails: this.currentPlanDetails
    }
    this.commonService.closingPopupWithSendData(sendData);
  }

  ngOnInit(): void {
    if (this.currentPlanData) {
      this.currentPlanDetails =  this.currentPlanData;
    }
  }

  onSelectedAddress(selectedAddress: any) {
    if (selectedAddress) {
      this.currentAddressSelected = selectedAddress.currentBillingAddress;
      if (selectedAddress.actionCalling === 'checkoutType') {
        this.paymentMethod();
      }
    }
  }

  onAddNewClicked() {
    this.commonService.closingPopupWithSendData({ actionType: 'OpenAddForm' });
  }

  checkBillingList(addressListLength: number) {
    if (addressListLength > 0) {
      this.isShowTermConditions = true;
    }
  }

  paymentMethod() {
    let sendData = {
       actionType: "Checkout",
       selectedAddress: this.currentAddressSelected,
       currentDetails: this.currentPlanDetails
    }
     this.commonService.closingPopupWithSendData(sendData);
  }
}
